import { createFileRoute } from '@tanstack/react-router';

import { RoutinesPage } from '~/features/routines/routines-page';

/** Routines (docs/plans/routines.md R1, R5): what RecordOS does by itself. */
export const Route = createFileRoute('/_app/routines/')({
  component: RoutinesPage,
});
